exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".markdown p[data-v-c21c1ab0]:last-child {\n  margin-bottom: 0;\n}", ""]);

